import { render, staticRenderFns } from "./CardDashboardLayoutInfo.vue?vue&type=template&id=9f0ffb82"
import script from "./CardDashboardLayoutInfo.vue?vue&type=script&lang=js"
export * from "./CardDashboardLayoutInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports